<template>
  <div class="login-container">
    <div class="login-view">
      <div class="login-btn" @click="dandianlogin">
        <img
          v-if="loging"
          class="loging-img"
          src="../../static/img/login/loging.gif"
        />
        <span v-else>单点登录</span>
      </div>
    </div>

    <div :class="{ show: showTips === true }" class="tips">
      <img class="img" src="../../static/img/login/icon_login_tips.png" />
      <span class="msg">{{ alertMsg }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      // appId: 1101132,
      appId: 1101134, // 测试环境
      showTips: false,
      loging: false,
    };
  },
  mounted() {
    const tokenCode = this.getUrlParams("TokenCode");
    if (tokenCode) {
      // 有值表示是从单点跳转过来的
      this.loging = true;
      const params = {
        token_code: tokenCode,
      };

      this.APIS.DAN_DIAN_LOGIN(params).then((res) => {
        switch (res.data.status) {
          case 0:
            // 设置用户基本信息
            this.$store.commit("set_user_info", res.data.user_info);
            // 保存用户信息到cookie，时长3h，和后端保持一致
            // MyCookies.setCookie('user_info', JSON.stringify(res.data.user_info), 3, '/p')
            localStorage.setItem(
              "userInfo",
              JSON.stringify(res.data.user_info)
            );
            // TODO: 请求菜金确认接口，判断是否需要菜金确认
            // this.APIS.GET_MONEY_CONFIRM()
            // .then(data => {
            //   this.$store.commit('set_is_feedback', res.data.state)
            // })
            this.getMoneyConfirm();

            // 网页跳转到主界面
            this.$router.push("/p/meals");
            break;
          case 1:
          case 2:
            this.showAlert(res.data.message + " : )");
            break;
        }

        this.loging = false;
      });
    }
  },
  methods: {
    /**
     * 令Tips显示5秒后消失
     */
    showAlert(msg) {
      var _this = this,
        timer = null;
      _this.alertMsg = msg;
      this.showTips = true;
      clearTimeout(timer);
      timer = setTimeout(() => (this.showTips = false), 5000);
    },
    // 获取菜金确认情况
    getMoneyConfirm() {
      this.APIS.GET_MONEY_CONFIRM().then((res) => {
        if (res.data.status === 0) {
          this.$store.commit("set_is_feedback", res.data.is_check);
        } else {
          this.$store.commit("show_alert", res.data.message);
        }
      });
    },
    dandianlogin() {
      this.get_redirect();
      window.location.href = `https://dcsso.dianchu.com/oauth?appid=${
        this.appId
      }&checkbox=1&exptime=10800&redirecturi=${
        window.location.origin + window.location.pathname
      }`;
    },
    get_redirect() {
      let search = window.location.search;
      search = search.replace(/%3D/g, "=");
      search = search.replace(/%3F/g, "&");
      search = search.replace(/%2F/g, "/");
      sessionStorage.setItem("redirect", this.getUrlParams("redirect", search));
      sessionStorage.setItem("task_id", this.getUrlParams("task_id", search));
    },
    getUrlParams(paramsName, search) {
      // 获取路径参数
      var url = document.location.toString();
      if (search) {
        url = search;
      }
      var arrObj = url.split("?");
      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;
        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");
          if (arr !== null && arr[0] === paramsName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped lang="less">
.login-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url("../../static/img/login/pic_login.png") no-repeat;
  background-size: 100% 100%;
  .login-view {
    width: 480px;
    height: 460px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("../../static/img/login/bg_login.png") no-repeat;
    border-radius: 8px;
    position: relative;
    .login-btn {
      width: 380px;
      height: 60px;
      background-color: #ff9a28;
      border-radius: 30px;
      position: absolute;
      bottom: 27%;
      left: 50px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 20px;
    }
  }
  .tips {
    width: 480px;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #000000;
    border-radius: 30px;
    opacity: 0.5;
    margin-top: 10px;
    visibility: hidden;
    .img {
      width: 30px;
      height: 30px;
    }
    .msg {
      display: inline-block;
      font-size: 18px;
      color: #fefefe;
      margin-left: 10px;
    }
  }
  .show {
    visibility: visible;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue